import { ref, watch } from 'vue';

import { isDef } from '/@/utils/is';
import axios from 'axios';
interface Options {
  target?: HTMLElement;
}
export function useCopyToClipboard(initial?: string) {
  const clipboardRef = ref(initial || '');
  const isSuccessRef = ref(false);
  const copiedRef = ref(false);

  watch(
    clipboardRef,
    (str?: string) => {
      if (isDef(str)) {
        copiedRef.value = true;
        isSuccessRef.value = copyTextToClipboard(str);
      }
    },
    { immediate: !!initial, flush: 'sync' },
  );

  return { clipboardRef, isSuccessRef, copiedRef };
}

export function copyTextToClipboard(input: string, { target = document.body }: Options = {}) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(input).then(
      function () {
        console.log('Copying to clipboard was successful!');
      },
      function (err) {
        console.error('Could not copy text: ', err);
        copyTextWithoutWebAPI(input, target);
      },
    );
    return true;
  } else {
    copyTextWithoutWebAPI(input, target);
  }
}

function copyTextWithoutWebAPI(input: string, target) {
  const element = document.createElement('textarea');
  const previouslyFocusedElement = document.activeElement;

  element.value = input;

  element.setAttribute('readonly', '');

  (element.style as any).contain = 'strict';
  element.style.position = 'absolute';
  element.style.left = '-9999px';
  element.style.fontSize = '12pt';

  const selection = document.getSelection();
  let originalRange;
  if (selection && selection.rangeCount > 0) {
    originalRange = selection.getRangeAt(0);
  }

  target.append(element);
  element.select();

  element.selectionStart = 0;
  element.selectionEnd = input.length;

  let isSuccess = false;
  try {
    isSuccess = document.execCommand('copy');
  } catch (e: any) {
    throw new Error(e);
  }

  element.remove();

  if (originalRange && selection) {
    selection.removeAllRanges();
    selection.addRange(originalRange);
  }

  if (previouslyFocusedElement) {
    (previouslyFocusedElement as HTMLElement).focus();
  }
  return isSuccess;
}

export function copyImageToClipboard(url: string) {
  axios({
    method: 'get',
    url: url, // 请求地址
    responseType: 'blob', // 设置接收格式为blob格式
  }).then((res) => {
    if (res && res.data && res.data.size) {
      const dataInfo = res.data;
      const reader = new window.FileReader();
      // 使用readAsArrayBuffer读取文件, result属性中将包含一个 ArrayBuffer 对象以表示所读取文件的数据
      reader.readAsArrayBuffer(dataInfo);
      reader.onload = function (e) {
        const result = e.target!.result;
        // 转为 png
        const contentType = 'image/png'; // dataInfo.type;
        // 生成blob图片,需要参数(字节数组, 文件类型)
        const blob = new Blob([result!], { type: contentType });
        const item = new ClipboardItem({ [contentType]: blob });
        navigator.clipboard
          .write([item])
          .then(() => {
            console.log('图片已复制到剪贴板');
          })
          .catch((error) => {
            console.error('复制图片失败:', error);
          });
      };
    }
  });
}
